import { MatxLoadable } from "matx";
import { authRoles } from "../../auth/authRoles";

const Branch = MatxLoadable({
    loader: () =>
        import ("./New")
})

const Routes = [{
    path: "/datasetup/emailtype",
    component: Branch,
    auth: authRoles.Email_Setting
}];

export default Routes;